import React, {useEffect, useState} from "react";
import classNames from "classnames";

interface LoadingCircleProps {
    duration: number;
    filter: any;
    optionalText?: string;
    additionalClasses?: string;
}

export const LoadingCircle = ({duration, filter, optionalText, additionalClasses}: LoadingCircleProps) => {
    const [progress, setProgress] = useState(0);
    const [done, setDone] = useState(false);

    useEffect(() => {
        setProgress(0);
        setDone(false);
        const intervalDuration = duration / 100;
        const interval = setInterval(() => {
            setProgress(prev => {
                if (prev >= 100) {
                    clearInterval(interval);
                    setDone(true);
                    return 100;
                }
                return prev + 1;
            });
        }, intervalDuration);

        return () => clearInterval(interval);
    }, [duration, filter]);

    if (done) return null;

    const radius = 9;
    const circumference = 2 * Math.PI * radius;
    const offset = circumference - (progress / 100) * circumference;

    return (
        <div className={classNames("flex-container-row align-items-center margin-right-m", additionalClasses)}>
            <div className="loading-circle">
                <svg height="24" width="24">
                    <circle
                        className="circle-bg"
                        cx="12"
                        cy="12"
                        r={radius}
                    />
                    <circle
                        className="circle-progress"
                        cx="12"
                        cy="12"
                        r={radius}
                        strokeDasharray={circumference}
                        strokeDashoffset={offset}
                    />
                </svg>
            </div>
            <p className={"margin-0"}>{optionalText}</p>
        </div>
    );
};
